import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { ReturnSvgFilter } from "../ReturnSvgFilter";
import config from "../../config/app.json";
import itemConfig from "../../config/itemConfig.json";
import { FRAME_CLASSES, getFrameClipFilterId, getFrameClipFilterSvgId, getFrameClipVignetteId } from "../../helpers/frameHelper";

const appUrl = config['APPICONS'][config['APPICONS']['current']];

const Loader = styled.div`
    width: 100%;
    height: 100%;
    position: absolute; top: 0; left: 0;
    display: flex; align-items: center; justify-content: center;

    img {
        width: 100%;
        max-height: 48px;
        object-fit: contain;
    }
`

const FrameImage = styled.img`
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
`;

const FrameVideo = styled.video`
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
`;

const VIGNETTE = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 2;
    background-image: radial-gradient(
        circle farthest-side at center center,
        rgba(0, 0, 0, 0) 70%,
        rgba(0, 0, 0, var(--vignette)) 130%
    );
`;

function FilterItem(props) {
    const {
        id, clip, ItemID, filterCode, filterId, browserName, idPrefix,
    } = props;

    return (
        <React.Fragment>
            <div>
                <svg
                    id={getFrameClipFilterSvgId(ItemID, clip, idPrefix)}
                    style={
                        browserName === "Firefox"
                            ? { width: "0", height: "0", display: "block" }
                            : { display: "none" }
                    }
                >
                    <defs>
                        <filter colorInterpolationFilters="sRGB" id={filterId}>
                            <ReturnSvgFilter filterCode={filterCode} />
                        </filter>
                    </defs>
                </svg>
            </div>
        </React.Fragment>
    );
}

function InnerFrameImageComponent(props) {

    const { // from parent
        Id, clip_id, showImage, isFraming, containerStyles, src, imageRef, imageContainerRef,
        droppableItemData, totalLength, currIndex, thumb, isImageHovered, idPrefix,
    } = props;

    const { // from redux
        browserName,
    } = props;

    const [loading, setLoading] = useState(true);
    const [loadingImg, setLoadingImg] = useState();

    useEffect(() => {
        let image = new Image();
        setLoading(true);
        image.onload = () => {
            setLoading(false);
        };
        image.onerror = () => {
            setLoading(false);
        };
        image.src = src;
        setLoadingImg(image);
    }, [src]);

    if (showImage && !isFraming && !loading) {
        const filterData = droppableItemData.getIn(["imgDetails", "filter"])
            ? droppableItemData.getIn(["imgDetails", "filter"])
            : itemConfig["IMAGE"]["DEFAULT_FILTER"];
        const vignetteValue = parseInt(filterData.substr(12, 2), 16);
        const vignetteId = getFrameClipVignetteId(Id, clip_id, idPrefix);
        const filterId = getFrameClipFilterId(Id, clip_id, filterData, idPrefix);
        const type = droppableItemData.getIn(["imgDetails", "type"]);
        const subType = droppableItemData.getIn(["imgDetails", "subType"]);
        let imgSrc = loadingImg.src;
        let isVideo = false;
        let videoSrc = "";
        if(type === "STOCKVID" || (type === "UPLOADS" && subType === "UPVIDEO") || (type === "PEXELS" && subType === "VIDEO") || (type === "PIXABAY" && subType === "VIDEO") || subType === "OBGVID") {
            if((type === "UPLOADS" && subType === "UPVIDEO")) {
                if(!thumb.includes("https")) {
                    loadingImg.src = config["UPLOADS"][config["UPLOADS"][(subType) ? 'onload_' + subType : 'workspace']] + thumb
                }
                let thumbSource = thumb;
                if(!thumbSource.includes("https")) {
                    thumbSource = config["UPLOADS"][config["UPLOADS"][(subType) ? 'onload_' + subType : 'workspace']] + thumb
                }
                imgSrc = isImageHovered ? loadingImg.src : thumbSource;
                isVideo = true;
                videoSrc = config["UPLOADS"][config["UPLOADS"][(subType) ? 'onload_' + subType : 'workspace']] + src;
            } else if(type === "STOCKVID") {
                let thumbSource = thumb;
                if(!thumbSource.includes("https")) {
                    thumbSource = config[type][config[type].onload] + thumb;
                }
                imgSrc = isImageHovered ? loadingImg.src : thumbSource;
                isVideo = true;
                videoSrc = config[type][config[type].workspace] + src;
            } else if((type === "PEXELS" && subType === "VIDEO") || (type === "PIXABAY" && subType === "VIDEO")) {
                imgSrc = isImageHovered ? loadingImg.src : thumb;
                isVideo = true;
                videoSrc = src;
            } else if(subType === "OBGVID") {
                let thumbSource = thumb;
                if(!thumb.includes("https")) {
                    loadingImg.src = `${config.ASSETS[config.ASSETS.current]}${config.BG.obgsrc}${thumbSource}`;
                }
                if(!thumbSource.includes("https")) {
                    thumbSource = `${config.ASSETS[config.ASSETS.current]}${config.BG.obgsrc}${thumbSource}`;
                }
                imgSrc = isImageHovered ? loadingImg.src : thumbSource;
                videoSrc = `${config.ASSETS[config.ASSETS.current]}${config.BG.obgsrc}${src}`;
            }
        }
        const onLoadImage = (currIndex, status, imgSrc) => {
            try {
                if (status === true) {
                    console.log(currIndex, status, imgSrc, props.onLoadData, `${clip_id}-${props.Id}`)
                    let imageId = `${clip_id}-${props.Id}`; 
                    props.onLoadData(imageId)
                }
            } catch (error) {
                console.log(error)
            }
        }

        return (
            <div ref={imageContainerRef} style={containerStyles}>
                <FrameImage
                    clip={clip_id}
                    className={`img-item ${FRAME_CLASSES["INNER_IMAGE"]}`}
                    alt={"FrameImage"}
                    style={{
                        filter: `url(#${filterId})`,
                    }}
                    src={loading === false ? imgSrc : ""}
                    ref={imageRef}
                    draggable={false}
                    onLoad = {() => onLoadImage(currIndex, true, imgSrc)}
                    onError = {() => onLoadImage(currIndex, false, imgSrc)}
                />
                {
                    //  <FrameVideo src={videoSrc} className = {`frame-video-${Id}-${clip_id}`} style = {{ display: isImageHovered ? "none" : "block", filter: `url(#${filterId})` }} onLoadedData = {() => props.onLoadData(currIndex)}/> //: null
                }

                <VIGNETTE
                    id={vignetteId}
                    className="vignette"
                    style={{
                        "--vignette": vignetteValue * 0.007,
                    }}
                ></VIGNETTE>

                <FilterItem
                    key={`${clip_id}_filter`}
                    clip={clip_id}
                    filterId={filterId}
                    filterCode={filterData}
                    ItemID={Id}
                    browserName={browserName}
                    idPrefix={idPrefix}
                />
            </div>
        );
    } else if (loading) {
        return (
            <Loader>
                <img alt="loader" src={appUrl + "/images/chr-loading.gif"} />
            </Loader>
        )
    } else {
        return <React.Fragment></React.Fragment>;
    }
}

export default InnerFrameImageComponent;


// WEBPACK FOOTER //
// ./src/components/Frame/InnerFrameImageComponent.js